exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-analytics-reports-reports-styles__nonRoundedTop {\n\tborder-top-right-radius: 0rem;\n\tborder-top-left-radius: 0rem;\n}\n\n.src-analytics-reports-reports-styles__headerBox {\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n.src-analytics-reports-reports-styles__alertBox {\n\tposition: relative;\n}\n", ""]);

// exports
exports.locals = {
	"nonRoundedTop": "src-analytics-reports-reports-styles__nonRoundedTop",
	"headerBox": "src-analytics-reports-reports-styles__headerBox",
	"alertBox": "src-analytics-reports-reports-styles__alertBox"
};